import { Action } from 'redux';
import { Table } from 'src/types/model';

export interface TableState {
  loading: boolean;
  data: Table[];
  error: string | null;
}

export const FETCH_TABLE_REQUEST = 'FETCH_TABLE_REQUEST';
export const FETCH_TABLE_SUCCESS = 'FETCH_TABLE_SUCCESS';
export const FETCH_TABLE_FAILURE = 'FETCH_TABLE_FAILURE';

export interface FetchTableRequestAction
  extends Action<typeof FETCH_TABLE_REQUEST> {}

export interface FetchTableSuccessAction
  extends Action<typeof FETCH_TABLE_SUCCESS> {
  payload: Table[];
}

export interface FetchTableFailureAction
  extends Action<typeof FETCH_TABLE_FAILURE> {
  payload: string;
}

export type TableActionType =
  | FetchTableRequestAction
  | FetchTableSuccessAction
  | FetchTableFailureAction;
